<template>
    <v-row class="fill-height" align="center" justify="center" >
        <v-card>
            <v-card-title>
                <v-progress-circular indeterminate></v-progress-circular>
                <span class="spinnerText">Logging In...</span>
            </v-card-title>
        </v-card>
    </v-row>
</template>

<script>
export default {
    components: {

    },
    data() {
        return {
            
        };
    },
    methods: {
        
    },
    mounted() {
        this.$router.push({name: "home"});
    }
};
</script>

<style scoped>
.spinnerText {
    margin-left: 15px;
}
</style>